import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "formulaire",
  class: "py-5"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 mx-auto" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "row g-3" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "col-md-8" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "row g-3" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "d-flex flex-wrap justify-content-center" }
const _hoisted_22 = ["id", "value"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "form-check mb-4" }

import Vue, { ref } from "vue";
import { send } from "emailjs-com";
import { useToast } from "vue-toastification";


export default /*@__PURE__*/_defineComponent({
  __name: 'PreInscription',
  setup(__props) {

const alreadySummit = ref(false);
const toast = useToast();
// Structure all form data in a single reactive object
const formData = ref({
  parents: {
    lastname: "",
    firstname: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    zipCode: ""
  },
  child: {
    firstname: "",
    bithdate: ""
  },
  contract: {
    start: "",
    end: ""
  },
  days: [], // Array to store checked days
  agreement: false
});

// List of days to generate checkboxes
const jours = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];

const handleSubmit = () => {
  if (formData.value.agreement === true && alreadySummit.value === false) {
    let dayText = "";
    alreadySummit.value = true;
    formData.value.days.forEach(day => {
      dayText += `- ${day} - `;
    });

    send(
      "service_vnvta9q",
      "template_5jzl58n",
      {
        lastname: formData.value.parents.lastname,
        firstname: formData.value.parents.firstname,
        email: formData.value.parents.email,
        phone: formData.value.parents.phone,
        adress: formData.value.parents.address,
        city: formData.value.parents.city,
        postalCode: formData.value.parents.zipCode,
        childName: formData.value.child.firstname,
        childBirthdate: formData.value.child.bithdate,
        start: formData.value.contract.start,
        end: formData.value.contract.end,
        week: dayText
      },
      process.env.VUE_APP_USER_ID
    )
      .then(() => {
        toast.success(
          "Votre pré-inscription a bien été transmise à l'équipe BébéBulle"
        );
      }).catch(() => {
      toast.error(
        "Une erreur est survenue lors de la transmission de vos informations."
      );
    }).finally(() => {
      alreadySummit.value = false;
      formData.value = {
        parents: {
          lastname: "",
          firstname: "",
          email: "",
          phone: "",
          address: "",
          city: "",
          zipCode: ""
        },
        child: {
          firstname: "",
          bithdate: ""
        },
        contract: {
          start: "",
          end: ""
        },
        days: [], // Array to store checked days
        agreement: false
      };
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-center mb-5" }, [
            _createElementVNode("h2", { class: "display-5 fw-bold" }, "Demande de pré-inscription"),
            _createElementVNode("p", { class: "lead text-muted" }, " Remplissez ce formulaire pour initier votre demande. Nous vous recontacterons très prochainement. ")
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleSubmit, ["prevent"])
          }, [
            _createElementVNode("fieldset", _hoisted_5, [
              _cache[20] || (_cache[20] = _createElementVNode("legend", { class: "h5 mb-3 border-bottom pb-2" }, "1. Vos informations de contact", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "parentNom",
                    class: "form-label"
                  }, "Nom", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "parentNom",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.parents.lastname) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.parents.lastname]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    for: "parentPrenom",
                    class: "form-label"
                  }, "Prénom", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "parentPrenom",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.parents.firstname) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.parents.firstname]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    for: "parentEmail",
                    class: "form-label"
                  }, "Email", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "parentEmail",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.parents.email) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.parents.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    for: "parentTel",
                    class: "form-label"
                  }, "Téléphone", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "parentTel",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.parents.phone) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.parents.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", {
                    for: "parentAdresse",
                    class: "form-label"
                  }, "Adresse", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "parentAdresse",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.parents.address) = $event))
                  }, null, 512), [
                    [_vModelText, formData.value.parents.address]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    for: "parentVille",
                    class: "form-label"
                  }, "Ville", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "parentVille",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.parents.city) = $event))
                  }, null, 512), [
                    [_vModelText, formData.value.parents.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    for: "parentCP",
                    class: "form-label"
                  }, "Code Postal", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "parentCP",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.parents.zipCode) = $event))
                  }, null, 512), [
                    [_vModelText, formData.value.parents.zipCode]
                  ])
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_14, [
              _cache[25] || (_cache[25] = _createElementVNode("legend", { class: "h5 mb-3 border-bottom pb-2" }, "2. Informations sur l'enfant et le contrat", -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", {
                    for: "enfantNom",
                    class: "form-label"
                  }, "Nom de l'enfant", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "enfantNom",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.child.firstname) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.child.firstname]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                    for: "enfantNaissance",
                    class: "form-label"
                  }, "Date de naissance", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "enfantNaissance",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.child.bithdate) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.child.bithdate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", {
                    for: "contratDebut",
                    class: "form-label"
                  }, "Date de début de contrat souhaitée", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "contratDebut",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.contract.start) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.value.contract.start]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", {
                    for: "contratFin",
                    class: "form-label"
                  }, "Date de fin de contrat estimée", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "contratFin",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.contract.end) = $event))
                  }, null, 512), [
                    [_vModelText, formData.value.contract.end]
                  ])
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_20, [
              _cache[26] || (_cache[26] = _createElementVNode("legend", { class: "h5 mb-3 border-bottom pb-2" }, "3. Jours d'accueil souhaités", -1)),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jours, (jour) => {
                  return _createElementVNode("div", {
                    key: jour,
                    class: "form-check form-check-inline me-3 mb-2"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: `check-${jour}`,
                      value: jour,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.days) = $event))
                    }, null, 8, _hoisted_22), [
                      [_vModelCheckbox, formData.value.days]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: `check-${jour}`
                    }, _toDisplayString(jour), 9, _hoisted_23)
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "consent",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.agreement) = $event)),
                required: ""
              }, null, 512), [
                [_vModelCheckbox, formData.value.agreement]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                class: "form-check-label",
                for: "consent"
              }, " J'autorise ce site à conserver mes données transmises via ce formulaire. ", -1))
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary btn-lg"
              }, [
                _createElementVNode("i", { class: "bi bi-send-fill me-2" }),
                _createTextVNode("Envoyer ma demande ")
              ])
            ], -1))
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})